module.exports = __webpack_public_path__ + "media/images/admin/icons/minus-square-8d669f15adb02523d6793d09e3992072.svg";